















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class SidebarNavLink extends Vue {
  @Prop({ default: "" })
  public name: string;

  @Prop({ default: "" })
  public url: string;

  @Prop({ default: "" })
  public icon: string;

  @Prop()
  public badge: any;

  @Prop({ default: "" })
  public variant: string;

  @Prop({ default: "" })
  public classes: string;

  get classList() {
    return ["nav-link", this.linkVariant, ...this.itemClasses];
  }

  get linkVariant() {
    return this.variant ? `nav-link-${this.variant}` : "";
  }

  get itemClasses() {
    return this.classes ? this.classes.split(" ") : [];
  }

  get isExternalLink() {
    if (this.url.substring(0, 4) === "http") {
      return true;
    } else {
      return false;
    }
  }
}
